import ServiceEndpoints from "../ServiceEndpoints";

export interface FieldGuidanceItem {
    key: string;
    value: string;
}

export async function fetchFieldGuidance(userToken?: string): Promise<FieldGuidanceItem[]> {
    return await fetch(ServiceEndpoints.FetchFieldGuidance, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + userToken,
        },
    }).then(async (resp) => {
        const data: FieldGuidanceItem[] = await resp.json();
        return data;
    }).catch((error) => {
        console.error("Error fetching field guidance:", error);
        return [];
    });
}

export async function updateFieldGuidance(key: string, value: string, userToken?: string): Promise<boolean> {
    try {
        const response = await fetch(`${ServiceEndpoints.UpdateFieldGuidance}/${key}`, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + userToken,
            },
            body: JSON.stringify({ key, value }),
        });

        return response.ok;
    } catch (error) {
        console.error("Error updating field guidance:", error);
        return false;
    }
}
